import hr from './hr'
import personal from './personal'
import publics from './public'
import group from './group'
import favorite from './favorite'
import account from './account'
import auth from './auth'
import ipt from './ipt'

export default {
  auth,
  account,
  hr,
  personal,
  publics,
  group,
  favorite,
  ipt,
}
